import type { LangShort } from "@/i18n/locale";
// Calendar review copy stays local to this module to avoid unrelated locale edits.
const rows = {
  "EN": [
    "Guests (email addresses)",
    "Repeat",
    "Does not repeat",
    "Daily",
    "Weekly",
    "Monthly",
    "Yearly",
    "Every (interval)",
    "Total occurrences (2–100)",
    "I authorize invitations, updates or cancellations to these guests. The provider may send emails; delivery is not confirmed.",
    "Only this occurrence",
    "Entire series",
    "Review entire series",
    "Changes affect the entire series and may notify guests for modified occurrences.",
    "Review valid guest emails, repetition and notification consent.",
    "Guest notifications requested; email delivery is not confirmed.",
    "Repetition time zone",
    "I reviewed and approve the guests, repetition and affected occurrences.",
    "I approve applying this action to the entire series."
  ],
  "PT": [
    "Convidados (endereços de e-mail)",
    "Repetir",
    "Não repete",
    "Diariamente",
    "Semanalmente",
    "Mensalmente",
    "Anualmente",
    "A cada (intervalo)",
    "Total de ocorrências (2–100)",
    "Autorizo convites, atualizações ou cancelamentos para estes convidados. O provedor pode enviar e-mails; a entrega não foi confirmada.",
    "Somente esta ocorrência",
    "Toda a série",
    "Revisar toda a série",
    "As alterações afetam toda a série e podem notificar convidados das ocorrências modificadas.",
    "Revise os e-mails dos convidados, a repetição e a autorização de notificações.",
    "Notificações aos convidados solicitadas; entrega de e-mails não confirmada.",
    "Fuso horário da repetição",
    "Revisei e aprovo os convidados, a repetição e as ocorrências afetadas.",
    "Aprovo aplicar esta ação a toda a série."
  ],
  "NL": [
    "Gasten (e-mailadressen)",
    "Herhalen",
    "Niet herhalen",
    "Dagelijks",
    "Wekelijks",
    "Maandelijks",
    "Jaarlijks",
    "Elke (interval)",
    "Totaal aantal (2–100)",
    "Ik geef toestemming voor uitnodigingen, updates of annuleringen aan deze gasten. De provider kan e-mails sturen; bezorging is niet bevestigd.",
    "Alleen deze gebeurtenis",
    "Hele reeks",
    "Hele reeks bekijken",
    "Wijzigingen gelden voor de hele reeks en kunnen gasten van gewijzigde gebeurtenissen informeren.",
    "Controleer gastadressen, herhaling en toestemming voor meldingen.",
    "Meldingen aan gasten aangevraagd; e-mailbezorging is niet bevestigd.",
    "Tijdzone voor herhaling",
    "Ik heb de gasten, herhaling en betrokken gebeurtenissen gecontroleerd en keur deze goed.",
    "Ik keur toepassing van deze actie op de hele reeks goed."
  ],
  "ES": [
    "Invitados (direcciones de correo)",
    "Repetir",
    "No se repite",
    "Diariamente",
    "Semanalmente",
    "Mensualmente",
    "Anualmente",
    "Cada (intervalo)",
    "Total de repeticiones (2–100)",
    "Autorizo invitaciones, actualizaciones o cancelaciones para estos invitados. El proveedor puede enviar correos; la entrega no está confirmada.",
    "Solo esta repetición",
    "Toda la serie",
    "Revisar toda la serie",
    "Los cambios afectan a toda la serie y pueden notificar a invitados de repeticiones modificadas.",
    "Revisa los correos, la repetición y el permiso para notificaciones.",
    "Notificaciones solicitadas; entrega de correos no confirmada.",
    "Zona horaria de repetición",
    "He revisado y apruebo los invitados, la repetición y las ocurrencias afectadas.",
    "Apruebo aplicar esta acción a toda la serie."
  ],
  "FR": [
    "Invités (adresses e-mail)",
    "Répéter",
    "Ne se répète pas",
    "Chaque jour",
    "Chaque semaine",
    "Chaque mois",
    "Chaque année",
    "Tous les (intervalle)",
    "Nombre total (2–100)",
    "J’autorise les invitations, mises à jour ou annulations pour ces invités. Le fournisseur peut envoyer des e-mails ; leur réception n’est pas confirmée.",
    "Cette occurrence seulement",
    "Toute la série",
    "Vérifier toute la série",
    "Les modifications concernent toute la série et peuvent avertir les invités des occurrences modifiées.",
    "Vérifiez les adresses, la répétition et l’autorisation des notifications.",
    "Notifications demandées ; réception des e-mails non confirmée.",
    "Fuseau horaire de répétition",
    "J’ai vérifié et j’approuve les invités, la répétition et les occurrences concernées.",
    "J’approuve l’application de cette action à toute la série."
  ],
  "IT": [
    "Invitati (indirizzi email)",
    "Ripeti",
    "Non si ripete",
    "Ogni giorno",
    "Ogni settimana",
    "Ogni mese",
    "Ogni anno",
    "Ogni (intervallo)",
    "Occorrenze totali (2–100)",
    "Autorizzo inviti, aggiornamenti o annullamenti per questi invitati. Il provider può inviare email; la consegna non è confermata.",
    "Solo questa occorrenza",
    "Intera serie",
    "Rivedi intera serie",
    "Le modifiche riguardano l’intera serie e possono avvisare gli invitati delle occorrenze modificate.",
    "Controlla indirizzi, ripetizione e consenso alle notifiche.",
    "Notifiche richieste; consegna delle email non confermata.",
    "Fuso orario della ripetizione",
    "Ho verificato e approvo gli invitati, la ripetizione e le occorrenze interessate.",
    "Approvo l’applicazione di questa azione all’intera serie."
  ],
  "DE": [
    "Gäste (E-Mail-Adressen)",
    "Wiederholen",
    "Keine Wiederholung",
    "Täglich",
    "Wöchentlich",
    "Monatlich",
    "Jährlich",
    "Alle (Intervall)",
    "Gesamtzahl (2–100)",
    "Ich erlaube Einladungen, Änderungen oder Absagen an diese Gäste. Der Anbieter kann E-Mails senden; die Zustellung ist nicht bestätigt.",
    "Nur dieser Termin",
    "Gesamte Serie",
    "Gesamte Serie prüfen",
    "Änderungen betreffen die ganze Serie und können Gäste geänderter Termine benachrichtigen.",
    "Prüfe Adressen, Wiederholung und Zustimmung zu Benachrichtigungen.",
    "Benachrichtigungen angefordert; E-Mail-Zustellung nicht bestätigt.",
    "Zeitzone der Wiederholung",
    "Ich habe die Gäste, Wiederholung und betroffenen Termine geprüft und stimme ihnen zu.",
    "Ich stimme zu, diese Aktion auf die gesamte Serie anzuwenden."
  ],
  "PL": [
    "Goście (adresy e-mail)",
    "Powtarzaj",
    "Nie powtarza się",
    "Codziennie",
    "Co tydzień",
    "Co miesiąc",
    "Co rok",
    "Co (interwał)",
    "Łączna liczba (2–100)",
    "Zezwalam na zaproszenia, aktualizacje lub anulowania dla tych gości. Dostawca może wysłać e-maile; dostarczenie nie jest potwierdzone.",
    "Tylko to wystąpienie",
    "Cała seria",
    "Sprawdź całą serię",
    "Zmiany dotyczą całej serii i mogą powiadomić gości zmienionych wystąpień.",
    "Sprawdź adresy, powtarzanie i zgodę na powiadomienia.",
    "Zlecono powiadomienia; dostarczenie e-maili nie jest potwierdzone.",
    "Strefa czasowa powtarzania",
    "Sprawdzono gości, powtarzanie i objęte wystąpienia; zatwierdzam je.",
    "Zatwierdzam zastosowanie tego działania do całej serii."
  ],
  "BG": [
    "Гости (имейл адреси)",
    "Повтаряне",
    "Не се повтаря",
    "Ежедневно",
    "Ежеседмично",
    "Ежемесечно",
    "Ежегодно",
    "На всеки (интервал)",
    "Общ брой (2–100)",
    "Разрешавам покани, промени или отмяна за тези гости. Доставчикът може да изпрати имейли; доставката не е потвърдена.",
    "Само това събитие",
    "Цялата поредица",
    "Преглед на цялата поредица",
    "Промените засягат цялата поредица и могат да уведомят гостите за променени събития.",
    "Проверете адресите, повтарянето и разрешението за известия.",
    "Известията са заявени; доставката на имейли не е потвърдена.",
    "Часова зона на повтаряне",
    "Прегледах и одобрявам гостите, повтарянето и засегнатите събития.",
    "Одобрявам прилагането на това действие към цялата поредица."
  ]
} as const satisfies Record<Uppercase<LangShort>, readonly [string, string, string, string, string, string, string, string, string, string, string, string, string, string, string, string, string, string, string]>;
const keys = ["guests","repeat","none","daily","weekly","monthly","yearly","interval","count","notify","occurrence","series","openSeries","seriesReview","invalid","requested","recurrenceZone","optionsAccept","seriesAccept"] as const;
export function calendarAdvancedCopy(lang:string) {
  const row = rows[(lang==='PT-BR'?'PT':lang) as keyof typeof rows] || rows.EN;
  return Object.fromEntries(keys.map((key,index)=>[key,row[index]])) as Record<typeof keys[number],string>;
}
